import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "item-label ps-0 tiny-bottom-spacing" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "item-content mb-3"
}
const _hoisted_4 = {
  key: 1,
  class: "load-spinner",
  role: "status"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hydratedQuestions, (question, questionIndex) => {
    return (_openBlock(), _createElementBlock("div", { key: questionIndex }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", {
          innerHTML: question.text
        }, null, 8, _hoisted_2)
      ]),
      (question.isAnswerLoaded == true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(question.textValue ?? question.value), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
    ]))
  }), 128))
}